import getQueryString from 'bjxy-common/helper/getQueryString'

export default {
  entrepreneur: {
    namespaced: true,
    state: {
      config: {
        api: {
          upload: 'https://opengw.xiaoying.com/api/risksystem.risk_policy.risk_policy_other/v1/tencent_license_ocr_service/v1/upload_verify_orc',
          submit: '/h5/apply/submit_credit_info',
          info: '/h5/common/get_info_config?key=xiaoying.loanproduct.xiaoweidai.showAmount'
        },
        xreportData: {
          extendEvent: { referer: getQueryString('referer') ,status:getQueryString('status')},
          main: {
            pv: 'tongyong_qiyerenzhengye',
            back: 'fanhui',
            click: 'shangchuanzhaopiananniu',
            upload: 'shangchuanzhaopian',
            submit: 'wanchengrenzheng',
            checked: 'gouxuanxieyi'
          },
          result: {
            pv: 'tongyong_qiyerenzhengwanchengye',
            back: 'fanhui',
            done: 'fanhuishouye'
          }
        }
      }
    }
  }
}
